import { lazy, memo, Suspense } from "react";

/**
 * 마크다운 렌더러의 lazy 래퍼 — 결정 #1/#11/#12(6s+ 초기 로드 보호 + lazy-load).
 *
 * react-markdown + remark/rehype 묶음은 크다(수백 KB). 앱 첫 화면(대화 목록·설정)
 * 에는 필요 없으므로 초기 번들에서 떼어내고, 채팅방을 처음 열 때 동적 import한다.
 * 로딩되는 짧은 순간에는 평문(whitespace-pre-wrap)으로 폴백해 레이아웃이 튀지
 * 않게 한다 — 어차피 스트리밍 중에도 같은 평문 모양이라 일관적이다.
 */
const Inner = lazy(() => import("./MessageContent.js"));

function LazyMessageContentImpl({ text }: { text: string }) {
  return (
    <Suspense
      fallback={<div className="whitespace-pre-wrap break-words text-sm leading-relaxed">{text}</div>}
    >
      <Inner text={text} />
    </Suspense>
  );
}

export const LazyMessageContent = memo(LazyMessageContentImpl);
